import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/comp4.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-4530f19c")

_pushScopeId("data-v-4530f19c")
const _hoisted_1 = { id: "entire_planesearch_component" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "header" }, [
  /*#__PURE__*/_createVNode("h1", null, "All 1245 bus tickets to different places found")
], -1)
const _hoisted_3 = { class: "tickets_found col-mob-11" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "place_time_details" }, [
  /*#__PURE__*/_createVNode("div", { class: "time" }, [
    /*#__PURE__*/_createVNode("h3", null, [
      /*#__PURE__*/_createTextVNode("11:30 "),
      /*#__PURE__*/_createVNode("span", null, "AM")
    ]),
    /*#__PURE__*/_createVNode("p", null, "2 hours"),
    /*#__PURE__*/_createVNode("h3", null, [
      /*#__PURE__*/_createTextVNode("3:30 "),
      /*#__PURE__*/_createVNode("span", null, "PM")
    ])
  ]),
  /*#__PURE__*/_createVNode("div", { class: "show_route" }, [
    /*#__PURE__*/_createVNode("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "32",
      height: "127",
      viewBox: "0 0 32 127"
    }, [
      /*#__PURE__*/_createVNode("g", {
        id: "Ellipse_35",
        "data-name": "Ellipse 35",
        transform: "translate(1)",
        fill: "none",
        stroke: "#487fff",
        "stroke-width": "3"
      }, [
        /*#__PURE__*/_createVNode("circle", {
          cx: "15",
          cy: "15",
          r: "15",
          stroke: "none"
        }),
        /*#__PURE__*/_createVNode("circle", {
          cx: "15",
          cy: "15",
          r: "13.5",
          fill: "none"
        })
      ]),
      /*#__PURE__*/_createVNode("g", {
        id: "Ellipse_36",
        "data-name": "Ellipse 36",
        transform: "translate(7 6)",
        fill: "none",
        stroke: "#487fff",
        "stroke-width": "3"
      }, [
        /*#__PURE__*/_createVNode("circle", {
          cx: "9",
          cy: "9",
          r: "9",
          stroke: "none"
        }),
        /*#__PURE__*/_createVNode("circle", {
          cx: "9",
          cy: "9",
          r: "7.5",
          fill: "none"
        })
      ]),
      /*#__PURE__*/_createVNode("g", {
        id: "map-pin-line",
        transform: "translate(0 95)"
      }, [
        /*#__PURE__*/_createVNode("path", {
          id: "Path_79",
          "data-name": "Path 79",
          d: "M0,0H32V32H0Z",
          fill: "none"
        }),
        /*#__PURE__*/_createVNode("path", {
          id: "Path_80",
          "data-name": "Path 80",
          d: "M16,27.859l7.15-6.773a9.224,9.224,0,0,0,0-13.544,10.514,10.514,0,0,0-14.3,0,9.224,9.224,0,0,0,0,13.544Zm0,3.869L6.808,23.021a11.859,11.859,0,0,1,0-17.414,13.518,13.518,0,0,1,18.385,0,11.859,11.859,0,0,1,0,17.414ZM16,17.05a2.816,2.816,0,0,0,2.889-2.736,2.893,2.893,0,0,0-5.778,0A2.816,2.816,0,0,0,16,17.05Zm0,2.736a5.631,5.631,0,0,1-5.778-5.473A5.631,5.631,0,0,1,16,8.841a5.631,5.631,0,0,1,5.778,5.473A5.631,5.631,0,0,1,16,19.786Z",
          transform: "translate(0 0)",
          fill: "#487fff"
        })
      ]),
      /*#__PURE__*/_createVNode("line", {
        id: "Line_22",
        "data-name": "Line 22",
        y2: "70",
        transform: "translate(15.5 28.5)",
        fill: "none",
        stroke: "#487fff",
        "stroke-width": "3",
        "stroke-dasharray": "10"
      })
    ])
  ]),
  /*#__PURE__*/_createVNode("div", { class: "places" }, [
    /*#__PURE__*/_createVNode("h4", null, "Kicukiro"),
    /*#__PURE__*/_createVNode("p", null, "RN 345 K"),
    /*#__PURE__*/_createVNode("h4", null, "Nyarugenge")
  ])
], -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "bus_company" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    alt: "bus company"
  })
], -1)
const _hoisted_6 = { class: "book_now" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "more" }, [
  /*#__PURE__*/_createVNode("svg", {
    id: "more-2-fill",
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "18",
    viewBox: "0 0 24 24"
  }, [
    /*#__PURE__*/_createVNode("path", {
      id: "Path_69",
      "data-name": "Path 69",
      d: "M0,0H24V24H0Z",
      fill: "none"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "Path_70",
      "data-name": "Path 70",
      d: "M12,3a2,2,0,1,0,2,2A2.006,2.006,0,0,0,12,3Zm0,14a2,2,0,1,0,2,2A2.006,2.006,0,0,0,12,17Zm0-7a2,2,0,1,0,2,2A2.006,2.006,0,0,0,12,10Z",
      fill: "#1d2329"
    })
  ])
], -1)
const _hoisted_8 = { class: "book_now" }
const _hoisted_9 = { class: "book_btn" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "map" }, [
  /*#__PURE__*/_createVNode("svg", {
    id: "road-map-line",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 20 20"
  }, [
    /*#__PURE__*/_createVNode("path", {
      id: "Path_152",
      "data-name": "Path 152",
      d: "M0,0H20V20H0Z",
      fill: "none"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "Path_153",
      "data-name": "Path 153",
      d: "M3.6,5.163V15.545l4.052-1.757,4.8,2.429L16.4,14.5V4.122l1.042-.452a.4.4,0,0,1,.378.034.406.406,0,0,1,.18.338V15.571L12.4,18,7.6,15.571,2.558,17.758a.4.4,0,0,1-.378-.034A.406.406,0,0,1,2,17.386V5.857Zm9.794,4.129L10,12.726,6.606,9.292a4.9,4.9,0,0,1,0-6.869,4.76,4.76,0,0,1,6.788,0,4.9,4.9,0,0,1,0,6.869ZM10,10.437l2.262-2.29a3.265,3.265,0,0,0,0-4.58,3.173,3.173,0,0,0-4.526,0,3.265,3.265,0,0,0,0,4.58Z",
      transform: "translate(0 0)",
      fill: "#2c343a"
    })
  ]),
  /*#__PURE__*/_createVNode("p", null, "map")
], -1)
const _hoisted_11 = { class: "book" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Book")
const _hoisted_13 = /*#__PURE__*/_createVNode("svg", {
  id: "suitcase-3-line",
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 22 22"
}, [
  /*#__PURE__*/_createVNode("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M0,0H22V22H0Z",
    fill: "none"
  }),
  /*#__PURE__*/_createVNode("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M13.667,1a.9.9,0,0,1,.889.9V6.429h.889v-.9h1.778v.9h.889a.9.9,0,0,1,.889.9V18.19a.9.9,0,0,1-.889.9h-.889V20H15.444v-.9H6.556V20H4.778v-.9H3.889A.9.9,0,0,1,3,18.19V7.333a.9.9,0,0,1,.889-.9h.889v-.9H6.556v.9h.889V1.9A.9.9,0,0,1,8.333,1Zm3.556,7.238H4.778v9.048H17.222Zm-8.889.9v7.238H6.556V9.143Zm3.556,0v7.238H10.111V9.143Zm3.556,0v7.238H13.667V9.143ZM12.778,2.81H9.222V6.429h3.556Z",
    fill: "#fff"
  })
], -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "price" }, [
  /*#__PURE__*/_createVNode("div", { class: "price_money" }, [
    /*#__PURE__*/_createVNode("p", null, [
      /*#__PURE__*/_createTextVNode("450 "),
      /*#__PURE__*/_createVNode("span", null, "Rwf")
    ])
  ]),
  /*#__PURE__*/_createVNode("div", { class: "buy" }, [
    /*#__PURE__*/_createVNode("svg", {
      id: "exchange-dollar-line",
      xmlns: "http://www.w3.org/2000/svg",
      width: "18",
      height: "18",
      viewBox: "0 0 28 28"
    }, [
      /*#__PURE__*/_createVNode("path", {
        id: "Path_65",
        "data-name": "Path 65",
        d: "M0,0H28V28H0Z",
        fill: "none"
      }),
      /*#__PURE__*/_createVNode("path", {
        id: "Path_66",
        "data-name": "Path 66",
        d: "M22.785,17.724A9.649,9.649,0,0,0,20.321,6.812,9.476,9.476,0,0,0,9.271,5.664L8.089,3.579a11.832,11.832,0,0,1,11.867.029,12.046,12.046,0,0,1,4.9,15.324l1.6.929L21.5,22.517l-.2-5.657,1.484.863ZM5.215,10.276A9.649,9.649,0,0,0,7.68,21.188a9.476,9.476,0,0,0,11.05,1.149l1.182,2.084a11.832,11.832,0,0,1-11.867-.029A12.046,12.046,0,0,1,3.14,9.068l-1.6-.928L6.5,5.484l.2,5.657-1.484-.863ZM9.831,16.4h6.552a.6.6,0,0,0,0-1.2H11.618a3,3,0,0,1,0-6h1.191V8h2.382V9.2h2.978v2.4H11.618a.6.6,0,0,0,0,1.2h4.765a3,3,0,0,1,0,6H15.191V20H12.809V18.8H9.831Z",
        transform: "translate(0 0)",
        fill: "#c14c70"
      })
    ]),
    /*#__PURE__*/_createVNode("p", null, "Buy")
  ])
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      (_openBlock(), _createBlock(_Fragment, null, _renderList(10, (index) => {
        return _createVNode("div", {
          class: "ticket",
          key: index
        }, [
          _hoisted_4,
          _hoisted_5,
          _createVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode("div", _hoisted_8, [
              _createVNode("div", _hoisted_9, [
                _hoisted_10,
                _createVNode("div", _hoisted_11, [
                  _createVNode(_component_router_link, {
                    class: "link",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$store.commit('Booking/setTicketId', 'ticket._id') )),
                    to: { path: '/search/plane', query: { ticket: 'ticket._id' }}
                  }, {
                    default: _withId(() => [
                      _hoisted_12
                    ]),
                    _: 1
                  }, 8, ["to"]),
                  _hoisted_13
                ])
              ])
            ]),
            _hoisted_14
          ])
        ])
      }), 64))
    ])
  ]))
})